import MUISwipeableDrawer from '@material-ui/core/SwipeableDrawer';

const SwipeableDrawer = ({ children, ...otherProps }) => (
  <MUISwipeableDrawer {...otherProps}>{ children }</MUISwipeableDrawer>
)

export default SwipeableDrawer